<template>
  <el-table
    ref="tableRef"
    class="table_container table_tooltip_scale_fix"
    header-row-class-name="table_header"
    v-bind="tableAttrs"
    :border="border"
    :stripe=stripe 
  >
    <template
      v-for="{ prop, slot, ...rest } in columns"
      :key="prop"
    >
      <el-table-column
        v-if="!slot"
        :prop="prop"
        :show-overflow-tooltip="true"
        v-bind="rest"
      ></el-table-column>
      <el-table-column
        v-else-if="slot === 'operate'"
        :prop="prop"
        :label="rest.label || '操作'"
        v-bind="rest"
        fixed="right"
      >
        <template #default="{ row }">
          <div class="operate_btn">
            <el-button
              v-for="{
                label,
                vOn: { click, ...vOn },
                disabled = false,
                ...args
              } in rest.options"
              :key="label"
              v-bind="args || {}"
              v-on="vOn || {}"
              :disabled="
                typeof disabled === 'boolean' ? disabled : disabled(row)
              "
              @click="click($event, row)"
              text
              >{{ label }}</el-button
            >
            <el-dropdown
              v-if="rest.moreOptions?.length"
              @command="rest.command($event, row)"
            >
              <span class="el-dropdown-link">
                <el-button text class="more_btn">...</el-button>
                <!-- <el-icon color="#000"><ArrowDownBold /> </el-icon> -->
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-for="{ label, disabled = false, ...args } in rest.moreOptions"
                    v-bind="args || {}"
                    :disabled="
                      typeof disabled === 'boolean' ? disabled : disabled(row)
                    "
                    >{{ label }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" v-else v-bind="rest">
        <template #default="scope">
          <slot
            :name="rest.default || prop"
            :scope="{
              ...scope,
              ...rest,
              prop,
              slot,
              attrs:{
                prop,
                slot,
                ...rest
              },
            }"
            >{{ scope.row[prop] }}</slot
          >
        </template>
        <template v-if="rest.header || $slots[prop + 'Header']" #header="scope">
          <slot :name="rest.header || prop + 'Header'" :scope="{
              ...scope,
              ...rest,
              prop,
              slot,
              attrs:{
                prop,
                slot,
                ...rest
              },
            }"></slot>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount, useAttrs } from "vue";
import { ArrowDownBold, Search, Refresh } from "@element-plus/icons-vue";
const attrs = useAttrs();
const tableAttrs = computed(() => {
  const { columns, ...rest } = attrs;
  return rest;
});

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  border: {
    type: Boolean,
    default: false
  },
  stripe: {
    type: Boolean,
    default: false
  }
});

const columns = computed(() => {
  return props.columns.filter((item) => !item.hidden);
});

const emit = defineEmits([]);
const tableRef = ref()
const setCurrent = (row) => {
  tableRef.value.setCurrentRow(row)
}
defineExpose({
  setCurrent
})
</script>
<style lang="scss" scoped>
.table_tooltip_scale_fix {
  transform: scale(1.0);
  transform-origin: 0 0;
}
.table_container {
  :deep(.el-popper) {
    max-width: 300px;
  }
  :deep(.table_header) {
    th.el-table__cell {
      background-color: var(--jd-header-color) !important;
    }
    th .cell {
      display: flex;
    }
  }
  .operate_btn {
    display: flex;
    align-items: center;
    .more_btn {
      margin-left: 12px;
      vertical-align: middle;
    }
    span,
    .el-button,
    .el-icon,
    .el-dropdown,
    .el-dropdown-link {
      &:focus-visible {
        outline: none;
      }
    }
  }
  :deep(.el-checkbox) {
    height: 23px !important;
    line-height: 23px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
  }
  :deep(.ElTableFixedRow) {
    position: sticky;
    top: 0;
    bottom: 0;
    z-index: 999;
    // background:var(--theme-module-bg-light) !important;
    background: var(--jd-hover-color) !important;
  }
  :deep(.ElTableLightColumn) {
    // background:var(--theme-module-bg-light) !important;
    background: var(--jd-hover-color) !important;
  }
}
</style>
